export default {
  GET_MODELS: (state) => state.models,
  GET_MODEL: (state) => state.model,
};
